export interface SystemStateModel {
  systemType?: SystemType;
  state: SystemState;
  message?: string;
}


export enum SystemState {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
  MAINTENANCE = 'MAINTENANCE',
  PARTIAL_ONLINE = 'PARTIAL_ONLINE',
  OFFLINE_OR_MAINTENANCE = 'OFFLINE_OR_MAINTENANCE',
  UNKNOWN = 'UNKNOWN'
}

export enum SystemType {
  NECTA_ONE = 'NECTA_ONE',
  VENDOR_CATALOG = 'VENDOR_CATALOG'
} 